<template>
  <div
    class="absolute z-50 top-0 left-0 w-screen h-screen bg-red-600 flex justify-center items-center modal-backdrop"
    v-if="isShowModal"
  >
    <div class="modal bg-white shadow-xl rounded flex flex-col p-8 border">
      <div class="font-bold title text-blue-600 text-center">{{title}}</div>
      <div class="flex-grow pt-4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { modalMixin } from "../../mixins";
export default {
  name: "VModal",
  props: {
    buttons: {
      default: _ => [
        { text: "Cancel", type: "cancel" },
        { text: "Confirm", type: "primary" }
      ]
    },
    title: { default: "Title" }
  },
  data() {
    return {};
  },
  mixins: [modalMixin],
  computed: {},
  methods: {
    onClick(item) {
      this.$emit("click", item);
      this.$emit(item.text, item);
      if (item.type == "cancel") {
        this.$emit("onCancel");
      }
    }
  }
};
</script>

<style>
.modal-backdrop {
  background: rgba(59, 59, 61, 0.5);
}

.modal {
  min-width: 35vw;
  min-height: 20vh;
}

.title {
  letter-spacing: 1px;
}
</style>